import React from 'react'
import PlaceOfBusiness from '../../../templates/PlaceOfBusiness'

const PlaceOfBusinessFI = ({ params }) => <PlaceOfBusiness lang="FI" id={params.id} name={params.name} />

export default PlaceOfBusinessFI
